import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEdit,
  faTrash,
  faBinoculars,
  faUserSecret,
  faCheckCircle,
  faWarning,
  faCircleExclamation,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'

// NOTE: This page is meant to be a living design style guide of all the elements in use throughout the site to ensure consistency

export default function StyleGuide() {
  return (
    <div className="hero">
      <div className="hero-body">
        <h1>Style Guide Main Header (H1)</h1>
        <h2>Subheader (H2)</h2>
        <p>
          Body text Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ipsum
          lectus, bibendum in mollis a, efficitur non leo. In vitae erat nec quam accumsan varius.
          Vivamus ex urna, fringilla eleifend cursus sit amet, sodales in lectus. Etiam eget feugiat
          mi. Duis eleifend imperdiet eros at molestie. Donec quis sapien nec enim vestibulum
          blandit nec eget lacus. Quisque placerat cursus scelerisque.
        </p>

        <p>
          Nullam varius feugiat efficitur. Aliquam aliquam, nulla in rhoncus tincidunt, lorem nisl
          egestas arcu, in rhoncus leo mi vel metus. Proin interdum urna nulla, quis vehicula metus
          pretium at. Sed imperdiet velit tortor, porttitor consectetur ante laoreet et. Maecenas
          aliquet dolor gravida varius mollis. Pellentesque ante ex, malesuada eget eros sed,
          euismod consequat libero. Ut quis ligula sem. Praesent venenatis eros in mi cursus
          commodo. Quisque pellentesque metus sit amet lectus eleifend, sollicitudin rhoncus ipsum
          tristique.
        </p>
        <div className="has-background-light py-10">
          <div className="mt-4">
            <button className="button is-dark">Gray Standard Button</button>
            &nbsp;
            <button className="button is-danger">Final Button</button>
            &nbsp;
            <button className="button is-dark lox-button-spoof">
              <FontAwesomeIcon icon={faUserSecret} />
            </button>
          </div>
        </div>
        <div className="example_box__dark_blue">
          <div className="mt-4">
            <button className="button is-light">Gray Light Button</button>
          </div>
        </div>
        <div className="mt-4">
          <button className="button is-link">Action Button</button>
        </div>
        <div className="mt-4">
          <button className="button is-link" disabled>
            Disabled Button
          </button>
          &nbsp;
          <button className="button is-danger" disabled>
            Disabled Button
          </button>
          &nbsp;
          <button className="button is-dark" disabled>
            Disabled Button
          </button>
          &nbsp;
          <button className="button is-light" disabled>
            Disabled Button
          </button>
        </div>
        <div>
          <div className="formLabel">
            Field Label Here
            <button className="button lox-button-helper-text lox-no-border">
              <FontAwesomeIcon icon={faQuestionCircle} className="has-text-link" />
            </button>
            - Needs to be tighter to field - 1-2px space
          </div>
          <input type="text" placeholder="Placeholder text" />
        </div>
        <p />

        <table cellSpacing="0" cellPadding="0" className="table is-bordered">
          <thead>
            <tr className="lox-table-header">
              {' '}
              <th colSpan="7">Dropdown Options</th>
              {' '}
            </tr>
            <tr>
              <th>View</th>
              <th>ID</th>
              <th>Field 1</th>
              <th>Field 2</th>
              <th>Field 3</th>
              <th>Field 4</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr className="row">
              <td className="is-centered">
                <button className="button is-link lox-button-binoculars">
                  <FontAwesomeIcon icon={faBinoculars} />
                </button>
              </td>
              <td>1234</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td className="is-centered">
                <button className="button is-info lox-button-row-edit mr-1">
                  <i className="fa fa-edit" />
                </button>
                <button className="button is-danger lox-button-row-delete">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
            <tr className="row">
              <td className="is-centered">
                <button className="button is-link lox-button-binoculars">
                  <FontAwesomeIcon icon={faBinoculars} />
                </button>
              </td>
              <td>5678</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td className="is-centered">
                <button className="button is-info lox-button-row-edit mr-1">
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button className="button is-danger lox-button-row-delete">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <p />

        <table cellSpacing="0" cellPadding="0">
          <thead>
            <tr className="lox-table-header">
              <th colSpan="7">Dropdown Options</th>
            </tr>
            <tr>
              <th>View</th>
              <th>ID</th>
              <th>Field 1</th>
              <th>Field 2</th>
              <th>Field 3</th>
              <th>Field 4</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr className="row">
              <td className="is-centered">
                <button className="lox-button-binoculars">
                  <FontAwesomeIcon icon={faBinoculars} />
                </button>
              </td>
              <td>1234</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td className="is-centered">
                <button className="lox-button-row-edit">
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                &nbsp;
                <button className="lox-button-row-delete">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
            <tr className="row">
              <td className="is-centered">
                <button className="lox-button-binoculars">
                  <FontAwesomeIcon icon={faBinoculars} />
                </button>
              </td>
              <td>5678</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td>text</td>
              <td className="is-centered">
                <button className="lox-button-row-edit">
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                &nbsp;
                <button className="lox-button-row-delete">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <p />

        <div className="message lox-success-message">
          <h2>
            <FontAwesomeIcon icon={faCheckCircle} />
            {' '}
            Success
          </h2>
          <p>You have a success message here.</p>
        </div>
        <p />
        <div className="message lox-warning-message">
          <h2>
            <FontAwesomeIcon icon={faWarning} />
            {' '}
            Warning
          </h2>
          <p>You have a warning message here.</p>
        </div>
        <p />
        <div className="message lox-error-message">
          <h2>
            <FontAwesomeIcon icon={faCircleExclamation} />
            {' '}
            Error
          </h2>
          <p>You have an error message here!</p>
        </div>
      </div>
    </div>
  )
}
